/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import ActionCard from '../../components/ActionCard';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchPopupStatusRequest,
  RootState,
  useProductName,
  useraccountDetailsRequest,
  accountProtectionRequest,
  renderDescriptionParagraphs,
} from '@rb-serve-app/core';
import Spinner from '../../components/Spinner';
import { EventType, useAnalytics } from '../../ui/Analytics';
import { logBrazeCustomEvent } from '../../config/braze';
import FeatureFlagMessage from '../../components/FeatureFlagMessage';
import RequestNewCard from '../../components/RequestNewCard';
import { useSearchParams } from 'react-router-dom';
import CommanModal from '../../components/CommanModal';

const ManageCard: React.FC = (prop: any) => {
  const { trackEvent } = useAnalytics();
  const { contentfulData } = useSelector(
    (state: RootState) => state.contentful
  );
  const { accountId, customerId, accountDetails } = useSelector(
    (state: any) => state.user
  );
  const { activatePinError, changePinError } = useSelector(
    (state: RootState) => state.changePin
  );
  const { insurancedetailSuccess, loading } = useSelector(
    (state: RootState) => state.accountProtection
  );
  const { cardStructure, productName } = useProductName();
  useEffect(() => {
    trackEvent(EventType.PAGE_VIEW, 'manage card', globalThis.location.href);
    logBrazeCustomEvent('viewed_manage_card');
  }, [trackEvent]);
  useEffect(() => {
    const changePinStatus = Number(changePinError?.status);
    const activateCardStatus = Number(activatePinError?.status);

    const isErrorStatus = (status: number) => [404, 500].includes(status);

    if (isErrorStatus(changePinStatus)) {
      setErrModalContent({
        title: entries?.rb_change_pin?.webChangeActivateCardApi?.title,
        description:
          entries?.rb_change_pin?.webChangeActivateCardApi?.description,
      });
      setShowErrModal(true);
      setCurrentModal(''); // hide change pin modal
    }

    if (isErrorStatus(activateCardStatus)) {
      setErrModalContent({
        title: entries?.rb_change_pin?.webChangeActivateCardApi?.title,
        description:
          entries?.rb_change_pin?.webChangeActivateCardApi?.description,
      });
      setShowErrModal(true);
      setCurrentModal(''); // hide activate card modal
    }
  }, [changePinError, activatePinError]);

  const { entries, assets } = contentfulData;

  const dispatch = useDispatch();
  const [showFeatureFlagMessage, setShowFeatureFlagMessage] = useState(false);
  const [isRequestCardOpen, setIsRequestCardOpen] = useState(false);
  const [showErrModal, setShowErrModal] = useState(false);
  const [errModalContent, setErrModalContent] = useState({
    title: '',
    description: '',
  });

  const {
    loading: popupLoading,
    isWalletEnabled,
    isUserCanAddCard,
    NotRemindMeLater,
    status: popupStatus,
  } = useSelector((state: RootState) => state.popup);
  const { showActivateCardPopup = null } = popupStatus || {};
  useEffect(() => {
    // Only fetch if popup data is not already present
    if (accountId && (!popupStatus || Object.keys(popupStatus).length === 0)) {
      dispatch(fetchPopupStatusRequest({ accountId, customerId }));
    }
  }, [accountId, customerId, dispatch, popupStatus]);
  useEffect(() => {
    if (accountId && customerId) {
      if (insurancedetailSuccess === null) {
        dispatch(accountProtectionRequest({ accountId, customerId }));
      }
    }
  }, [accountId, customerId, dispatch]);

  const { rb_manage_card, rb_feature_flagging } = entries;

  const breadcrumbs = [
    {
      name: entries?.rb_navigation?.homeLogoTitle,
      href: '/home',
      icon: '/path/to/home-icon.png',
    },
    { name: rb_manage_card?.manageCardTitle, href: '/manage-card' },
  ];

  type CardType = {
    title: string;
    description: string;
    buttonText: string;
    buttonLink?: string;
    onCardCtaClick: () => void;
    img?: string;
    featureFlaggingInfo?: any; // Replace `any` with a more specific type if available
  };
  const [cards, setCards] = useState<CardType[]>([]);
  console.log(
    'cards',
    cards,
    rb_feature_flagging?.featureFlagging?.manage_card?.account_protection_web,
    insurancedetailSuccess?.insuranceEligibilityFlag,
    entries?.rb_feature_flagging?.featureFlagging?.manage_card?.accountProtectionExclusionList?.includes(
      accountDetails?.productName
    )
  );

  const insuranceIndicator =
    insurancedetailSuccess?.insuranceInformation?.enrolledInformation
      ?.insuranceIndicator === 'NOT_INSURED';

  useEffect(() => {
    if (popupStatus) {
      const tiles: CardType[] = [
        {
          title: showActivateCardPopup
            ? rb_manage_card?.manageCardsTiles.card_tiles[0].activate_title
            : rb_manage_card?.manageCardsTiles.card_tiles[0].title,
          description: showActivateCardPopup
            ? rb_manage_card?.manageCardsTiles.card_tiles[0].activate_subtitle
            : rb_manage_card?.manageCardsTiles.card_tiles[0].subtitle,
          buttonText: showActivateCardPopup
            ? rb_manage_card?.manageCardsTiles.card_tiles[0].activate_ctaTitle
            : rb_manage_card?.manageCardsTiles.card_tiles[0].ctaTitle,
          buttonLink: '/change-pin',
          onCardCtaClick: () =>
            trackClickEvent(
              showActivateCardPopup
                ? 'activate card | activate card'
                : 'change pin | change pin'
            ),
          img: assets?.[
            showActivateCardPopup
              ? rb_manage_card?.manageCardsTiles.card_tiles[0]
                  .imgMappingActivateCardName
              : rb_manage_card?.manageCardsTiles.card_tiles[0].imgMappingName
          ], // Assuming image URL comes from assets
          featureFlaggingInfo:
            rb_feature_flagging?.featureFlagging?.manage_card?.web_change_pin,
        },
        {
          title: rb_manage_card?.manageCardsTiles.card_tiles[1].title,
          description: rb_manage_card?.manageCardsTiles.card_tiles[1].subtitle,
          buttonText: rb_manage_card?.manageCardsTiles.card_tiles[1].ctaTitle,
          onCardCtaClick: () => trackClickEvent('lock unlock | lock or unlock'),
          buttonLink: '/lock-unlock',
          img: assets?.[
            rb_manage_card?.manageCardsTiles.card_tiles[1].imgMappingName
          ],
          featureFlaggingInfo:
            rb_feature_flagging?.featureFlagging?.manage_card?.lock_unlock,
        },
        {
          title: rb_manage_card?.manageCardsTiles.card_tiles[2].title,
          description: rb_manage_card?.manageCardsTiles.card_tiles[2].subtitle,
          buttonText: rb_manage_card?.manageCardsTiles.card_tiles[2].ctaTitle,
          // buttonLink: '/request-replacement',
          onCardCtaClick: () => {
            trackClickEvent('request replacement card | submit a request');
            setIsRequestCardOpen(true);
          },
          img: assets?.[
            rb_manage_card?.manageCardsTiles.card_tiles[2].imgMappingName
          ],
          featureFlaggingInfo:
            rb_feature_flagging?.featureFlagging?.manage_card
              ?.web_replacement_card,
        },
        {
          title: rb_manage_card?.manageCardsTiles.card_tiles[3].title,
          description: rb_manage_card?.manageCardsTiles.card_tiles[3].subtitle,
          buttonText: rb_manage_card?.manageCardsTiles.card_tiles[3].ctaTitle,
          // buttonLink: '/request-supplementary',
          onCardCtaClick: () =>
            trackClickEvent('request supplementary cards | request now'),
          img: assets?.[
            rb_manage_card?.manageCardsTiles.card_tiles[3].imgMappingName
          ],
          featureFlaggingInfo:
            rb_feature_flagging?.featureFlagging?.manage_card
              ?.supplementary_card,
        },
      ];
      const eligibilityFlag =
        insurancedetailSuccess?.insuranceEligibilityFlag === true;
      const hideFifthTile =
        entries?.rb_feature_flagging?.featureFlagging?.manage_card?.accountProtectionExclusionList?.includes(
          accountDetails?.productName
        ) ||
        !eligibilityFlag ||
        !rb_feature_flagging?.featureFlagging?.manage_card
          ?.account_protection_web;

      if (!hideFifthTile) {
        tiles.push({
          title: rb_manage_card?.manageCardsTiles.card_tiles[4].title,
          description: rb_manage_card?.manageCardsTiles.card_tiles[4].subtitle,
          buttonText: insuranceIndicator
            ? rb_manage_card?.manageCardsTiles.card_tiles[4].ctaTitle_notInsured
            : rb_manage_card?.manageCardsTiles?.card_tiles[4].ctaTitle,
          onCardCtaClick: () =>
            trackClickEvent('rogers account protection | enroll now'),
          img: assets?.[
            rb_manage_card?.manageCardsTiles.card_tiles[4].imgMappingName
          ],
          featureFlaggingInfo:
            rb_feature_flagging?.featureFlagging?.manage_card
              ?.account_protection_web,
        });
      }

      setCards(tiles);
    }
  }, [
    popupStatus,
    entries,
    accountDetails,
    assets,
    rb_manage_card,
    rb_feature_flagging,
    showActivateCardPopup,
    loading,
  ]);

  const [showInfoModal, setShowInfoModal] = useState(false);
  const [hasOpenedModal, setHasOpenedModal] = useState(false);
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action');
  const [currentModal, setCurrentModal] = useState('');
  useEffect(() => {
    if (
      action === 'activate-card' &&
      showActivateCardPopup &&
      !hasOpenedModal
    ) {
      setShowInfoModal(true);
      setHasOpenedModal(true);
      setCurrentModal('activate-card');
    }
  }, [action, showActivateCardPopup, hasOpenedModal]);

  const trackClickEvent = (name: string) => {
    trackEvent(
      EventType.CLICK_EVENT,
      'manage card',
      globalThis.location.href,
      `manage card | ${name}`
    );
  };

  if (!entries || !cardStructure?.imgUrl || popupLoading || loading) {
    return (
      <div className="flex justify-center items-center h-[80%] bg-slate-50 translate-x-2">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      {showFeatureFlagMessage && (
        <FeatureFlagMessage className="md:left-20 left-0" />
      )}
      <div className="bg-bg-body py-4 md:px-8 px-4">
        <Breadcrumbs items={breadcrumbs} />
        <div className="w-full m-[22px] mx-auto rounded-[15px] bg-white min-h-[70vh] my-0">
          <div className="bg-white md:p-6 p-4 rounded-lg">
            <h2
              className="text-[22px] font-semibold leading-[28px] tracking-[0.35%] pb-7"
              aria-label={rb_manage_card?.manageCardTitle}
            >
              {renderDescriptionParagraphs(rb_manage_card?.manageCardTitle)}
            </h2>
            <div className="bg-[#F5F5F5] flex flex-row justify-start p-[20px] items-center rounded-[10px] gap-[20px] mb-[30px]">
              <img
                src={cardStructure?.imgUrl}
                alt="CardImg"
                className="h-[90px]"
              />
              <div>
                {/* <span className="text-[#1F1F1F] block text-[15px] font-normal leading-[24px] tracking-[-0.036px]">
                Showing
              </span> */}
                <h3
                  aria-label={`${productName} ${accountDetails?.customer?.cardLast4}`}
                  className="text-[#1F1F1F] block text-[16px] font-semibold leading-[24px] tracking-[-0.051px]"
                >
                  {renderDescriptionParagraphs(
                    `${productName} ${accountDetails?.customer?.cardLast4}`
                  )}
                </h3>
              </div>
            </div>
            <div className="grid gap-6 xl:grid-cols-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 ">
              {!popupLoading &&
                cards.length > 0 &&
                cards.map((card, index) => (
                  <ActionCard
                    key={index}
                    img={card.img}
                    title={card.title}
                    description={card.description}
                    buttonText={card.buttonText}
                    buttonLink={card?.buttonLink}
                    customStyle="flex flex-row xl:flex-col lg:flex-row md:flex-col 2x1:flex-col
                 items-start xl:items-center md:items-center lg:items-start
                 p-[10px] xl:p-[30px] md:p-[30px] lg:p-[30px] pt-[20px] gap-[30px] border border-[#E9E9E9] rounded-lg bg-white sm:flex-col sm:justify-center sm:item-center"
                    onCardClick={card.onCardCtaClick}
                    setShowFeatureFlagMessage={setShowFeatureFlagMessage}
                    featureFlaggingData={card?.featureFlaggingInfo}
                    setIsRequestCardOpen={setIsRequestCardOpen}
                    showInfoModal={index === 0 ? showInfoModal : undefined}
                    setShowInfoModal={setShowInfoModal}
                    currentModal={currentModal}
                    setCurrentModal={setCurrentModal}
                    insuranceIndicator={insuranceIndicator}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
      {isRequestCardOpen && (
        <RequestNewCard
          isRequestCardOpen={isRequestCardOpen}
          setIsRequestCardOpen={setIsRequestCardOpen}
        />
      )}
      {showErrModal && (
        <CommanModal
          isOpen={true}
          jsxContent={
            <>
              <div
                aria-label={errModalContent.title}
                className="mt-[20px] text-lg font-semibold text-center"
              >
                {errModalContent.title}
              </div>
              <div
                aria-label={errModalContent.description}
                className="mt-[20px]"
              >
                {errModalContent.description}
              </div>
            </>
          }
          onClose={() => setShowErrModal(false)}
          buttonText={entries?.rb_change_pin?.changePin?.ok}
          cardStatus={true}
          closeIcon={false}
        />
      )}
    </>
  );
};

export default ManageCard;
